import React, {useEffect, useContext} from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

import {isEnabled} from '~/src/utilities/helpers/feature';
import {Feature} from '~/src/utilities/constants/feature';
import {ContentType} from '~/src/utilities/constants/types';
import {loadExternalDependency, waitForCondition} from '~/src/utilities/helpers/dependency';
import {ConsentContext} from '~/src/components/context/ConsentContext';

const {publicRuntimeConfig: config} = getConfig();

declare global {
    interface Window {
        OBR?: {
            extern?: {
                renderSpaWidgets(url: string): void;
            };
        };
    }
}

interface OutbrainProps {
    contentType: string;
    contextKey: string;
    canonicalUrl?: string;
}

const Outbrain = ({contentType, contextKey, canonicalUrl = ''}: OutbrainProps) => {
    const consent = useContext(ConsentContext);

    if (!isEnabled(Feature.OUTBRAIN) || contentType !== ContentType.ARTICLE) {
        return null;
    }

    process.browser &&
        useEffect(() => {
            if (consent.allowsTargeting) {
                loadExternalDependency({src: config.scripts.ads.outbrain})
                    .then(() => waitForCondition(() => typeof window?.OBR?.extern?.renderSpaWidgets === 'function'))
                    .then(() => window.OBR?.extern?.renderSpaWidgets(canonicalUrl));
            }
        }, [consent.allowsTargeting]);

    if (!consent.allowsTargeting) {
        return null;
    }

    return (
        <div>
            <Head>
                <script key="ob-context-key" dangerouslySetInnerHTML={{__html: `window.OB_ContextKeyValue='${contextKey}';`}}></script>
            </Head>

            <div className="OUTBRAIN" data-src={canonicalUrl} data-widget-id="AR_1"></div>
        </div>
    );
};

export default Outbrain;
